import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h3 {...{
      "id": "please-be-careful"
    }}>{`Please be careful`}</h3>
    <p>{`This method is safe to use in most simple cases, but in some cases it should not be used:`}</p>
    <ul>
      <li parentName="ul">{`If the updater gives you a primitive value or childless value, you can return anything.`}</li>
      <li parentName="ul">{`If the updater gives you a value that has children, you can always return a primitive value or childless value.`}</li>
      <li parentName="ul">{`If the updater gives you a value that has children, you can return a value with children `}<strong parentName="li">{`only if the shape hasn't changed`}</strong>{`.`}</li>
    </ul>
    <p>{`To find out why, and what to do about it, please read about `}<a parentName="p" {...{
        "href": "/dataparcels/parcel-updaters"
      }}>{`parcel updaters`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      